import React, { useEffect, useState } from "react";
import Background from "../../assets/images/bg/foravni.jpg";
import Background1 from "../../assets/images/breadcum/01.jpg";
import { Link } from "react-router-dom";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

export default function VisionValue() {
  const [dataDesc, setData] = useState("");
  const [title, setTitle] = useState("");

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("required"),
    Phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Invalid phone number")
      .required("required"),
    Email: Yup.string().email("Invalid email").required("required"),
    City: Yup.string().required("required"),
    School: Yup.string()
      .required("required")
      .notOneOf(["0"], "Please select a school"),
    Grade: Yup.string()
      .required("required")
      .notOneOf(["0"], "Please select a grade"),
    Message: Yup.string().required("required"),
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/cms/slug/vision-value`
        );
        setData(res.data.Description);
        setTitle(res.data.Title);
      } catch (error) {
        console.error("Error fetching content:", error);
      }
    };
    fetchData();
  }, []);

  const [data, setDataa] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getallNews`
        );
        setDataa(res.data);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };
    fetchData();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const handleRegister = async (values, { resetForm, setSubmitting }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/api/auth/create/Inquiry`,
        values
      );

      if (response) {
        alert("Your application has been submitted successfully!");
        resetForm();
      } else {
        alert("Application submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Application submission error:", error);
      alert("Application submission failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* <!--inner-header --> */}
      <section
        className="inner-banner bg-overlay-black-70 bg-holder"
        style={{ backgroundImage: `url(${Background1})` }}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-12">
              <div className="text-center">
                <h1 className="text-white">{title}</h1>
              </div>
              <div className="d-flex justify-content-center ">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#">About Us</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <span>{title}</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--inner-header --> */}

      {/* <!--about --> */}
      <section
        className="space-ptb bg-img"
        style={{
          backgroundImage: `url(${Background})`,
          paddingBottom: "0px",
          backgroundColor: "transparent",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div
                className="section-title"
                style={{
                  maxWidth: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {/* Content Injection */}
                {React.createElement("div", {
                  dangerouslySetInnerHTML: {
                    __html: `${dataDesc}<style>p{font-size:19px;font-weight:400} .text-primary, .text-primary span, h3, b, strong { color: #042364 !important; }</style>`,
                  },
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}
